/* =========================================================================
   EGONEX — Sepet çekmecesi ekstraları
   - Hızlı ekle (öneri şeridi)
   - İndirim kodu
   - Ücretsiz kargo barı / toplam / öneri şeridi tazeleme
   - Bildirim (toast)
   - Çekmece açılınca destek widget'ını gizle
   ========================================================================= */
(function () {
  'use strict';

  /* ------------------------------------------------------------- TOAST */
  function toast(message, type) {
    let stack = document.querySelector('.eg-toast-stack');
    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'eg-toast-stack';
      document.body.appendChild(stack);
    }
    const el = document.createElement('div');
    el.className = 'eg-toast' + (type ? ' eg-toast--' + type : '');
    el.setAttribute('role', 'status');
    el.textContent = message;
    stack.appendChild(el);
    setTimeout(() => {
      el.classList.add('is-leaving');
      setTimeout(() => el.remove(), 300);
    }, 2600);
  }
  window.egToast = toast;

  /* ------------------------------------------------- ÇEKMECE OLAY YAYINI */
  function watchDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const emit = () => {
      const open = drawer.classList.contains('active');
      document.documentElement.classList.toggle('eg-cart-open', open);
      document.dispatchEvent(
        new CustomEvent(open ? 'eg:overlay:open' : 'eg:overlay:close', { detail: { source: 'cart' } })
      );
    };

    new MutationObserver(emit).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* --------------------------------------------------------- HIZLI EKLE */
  function bindQuickAdd(root) {
    (root || document).querySelectorAll('[data-eg-quick-add]').forEach((btn) => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';

      btn.addEventListener('click', async () => {
        const id = btn.getAttribute('data-eg-quick-add');
        if (!id) return;
        btn.classList.add('is-loading');

        const body = JSON.stringify({
          items: [{ id: Number(id), quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        });

        try {
          const res = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body,
          });
          const data = await res.json();
          if (data.status) throw new Error(data.description || data.message);

          btn.classList.remove('is-loading');
          btn.classList.add('is-done');

          const drawer = document.querySelector('cart-drawer');
          if (drawer && data.sections) {
            drawer.renderContents({ sections: data.sections, id: id });
          }
          toast('Ürün sepete eklendi', 'success');
        } catch (err) {
          btn.classList.remove('is-loading');
          toast(err.message || 'Ürün eklenemedi', 'error');
        }
      });
    });
  }

  /* ------------------------------------------------------- İNDİRİM KODU */
  function bindCoupon(root) {
    const scope = root || document;
    const toggle = scope.querySelector('[data-eg-coupon-toggle]');
    if (toggle && !toggle.dataset.bound) {
      toggle.dataset.bound = '1';
      toggle.addEventListener('click', () => {
        const body = scope.querySelector('.eg-cart__coupon-body');
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        if (body) body.hidden = open;
        if (!open) setTimeout(() => body?.querySelector('input')?.focus(), 120);
      });
    }

    const apply = scope.querySelector('[data-eg-coupon-apply]');
    if (apply && !apply.dataset.bound) {
      apply.dataset.bound = '1';
      const run = () => {
        const input = scope.querySelector('[data-eg-coupon-input]');
        const code = (input?.value || '').trim();
        if (!code) {
          toast('Lütfen bir indirim kodu girin', 'error');
          input?.focus();
          return;
        }
        // Shopify indirim kodunu oturuma işler, ardından ödeme sayfasına yönlendirir.
        window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(
          window.routes.cart_url
        )}`;
      };
      apply.addEventListener('click', run);
      scope.querySelector('[data-eg-coupon-input]')?.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          run();
        }
      });
    }
  }

  /* --------------------------------- MOBİL ALT BAR SEPET SAYISI */
  function syncMobileCount() {
    const mobileCart = document.querySelector('[data-eg-mobile-cart] .eg-mobilebar__cart-icon');
    if (!mobileCart) return;
    const headerCount = document.querySelector('[data-eg-cart-count]');
    const count = headerCount ? parseInt(headerCount.textContent.trim(), 10) || 0 : 0;
    let badge = mobileCart.querySelector('.eg-mobilebar__count');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'eg-mobilebar__count';
        mobileCart.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  /* -------------------------------------- ÇEKMECE PARÇALARINI TAZELEME */
  const REFRESH_SELECTORS = ['.eg-cart__ship', '.eg-cart__upsell', '.eg-cart__summary', '.eg-cart__count'];

  let refreshTimer;
  async function refreshDrawerParts() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(async () => {
      try {
        const res = await fetch(`${window.routes.cart_url}?section_id=cart-drawer`);
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');

        REFRESH_SELECTORS.forEach((sel) => {
          const target = document.querySelector(sel);
          const source = doc.querySelector(sel);
          if (target && source) {
            target.replaceWith(source);
          } else if (target && !source) {
            target.remove();
          }
        });

        syncMobileCount();

        // Ödeme butonunun durumu
        const checkout = document.getElementById('CartDrawer-Checkout');
        const drawerEl = document.querySelector('cart-drawer');
        if (checkout && drawerEl) checkout.disabled = drawerEl.classList.contains('is-empty');

        bindQuickAdd(document);
        bindCoupon(document);
      } catch (e) {
        /* sessiz geç */
      }
    }, 120);
  }

  /* ------------------------------------------------------------- BAŞLAT */
  // Ürün kartı JS'i (egonex-card.js) bunları çağırır
  window.egRebindCart = () => {
    bindQuickAdd(document);
    bindCoupon(document);
  };
  window.egSyncCartCount = syncMobileCount;

  function init() {
    watchDrawer();
    bindQuickAdd(document);
    bindCoupon(document);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => refreshDrawerParts());
    } else {
      document.addEventListener('cart:refresh', refreshDrawerParts);
    }

    // Tema editöründe yeniden yüklenirse bağlantıları tazele
    document.addEventListener('shopify:section:load', () => {
      bindQuickAdd(document);
      bindCoupon(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
